import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDate } from '../../../utility/functions';
import Table from '../../../table/Table';

const CodeLiability = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.code.liability,
        isReport: true,
        headers: [
            {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Code Type',
                propKey: 'codeType',
                options: true
            }, {
                label: 'Description',
                propKey: 'description',
            }, {
                label: 'Issued Date',
                propKey: 'issuedDate',
                type: 'dateTime'
            }, {
                label: 'Expiration Date',
                propKey: 'expirationDate',
                type: 'dateTime'
            }, {
                label: 'Liability Per Use',
                propKey: 'liabilityPerUse',
            },  {
                label: 'Remaining Uses',
                propKey: 'remainingUses',
            },{
                label: 'Max Uses',
                propKey: 'maxUses',
            }, {
                label: 'Total Liability',
                propKey: 'totalLiability',
            },
        ],
        sticker: [
            {
                label: 'Total Liability',
                color: '#21D59B',
                callback: (data) => formatCurrency(data.reduce((a, b) => b.totalLiability + a, 0)),
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.code}</td>
                <td>{e.codeType}</td>
                <td>{e.description}</td>
                <td>{shortHandDate(e.issuedDate)}</td>
                <td>{e.expirationDate ? shortHandDate(e.expirationDate) : 'Unlimited'}</td>
                <td>{formatCurrency(e.liabilityPerUse)}</td>
                <td>{e.remainingUses}</td>
                <td>{e.maxUses}</td>
                <td>{formatCurrency(e.totalLiability)}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default CodeLiability;